import React from 'react';
import { useIntl } from 'react-intl';
import gql from 'graphql-tag';
import { compose } from '../../../../src/web/utils/react';
import { widget } from '../../../../src/web/components/widgets/decorators';
import useQuery from '../../../../modules/react/hooks/useQuery';
import { BUILDER } from '../../../../src/shared/abilities';
import { NAME, ID } from './properties';
import useMedia from '../../../../modules/react/hooks/useMedia';
import DesktopNavigation from './Navigation';
import MobileNavigation from './MobileNav';

const GET_NAVIGATION_DATA = gql`
  query GetCurrentSiteNavigation($locale: String!) {
    currentSite {
      companyId
      id
      navigation(locale: $locale) {
        id
        text
        page {
          id
          ...NavigationItemPageFields
        }
        ...NavigationItems
      }
    }
  }

  ${DesktopNavigation.fragments.page}
  ${DesktopNavigation.fragments.navigationItem}
`;

const Nav = () => {
  const isMobile = useMedia(['(max-width:768px)'], [true], false);
  const { locale } = useIntl();
  const { data } = useQuery(GET_NAVIGATION_DATA, { variables: { locale } });

  const CurrentNav = isMobile ? MobileNavigation : DesktopNavigation;

  if (!data) {
    return <CurrentNav />;
  }

  const { currentSite: { navigation } } = data;
  return <CurrentNav navigation={navigation} />;
};

const component = compose(
  widget(
    { name: NAME, deprecated: true, componentId: ID },
  ),
)(Nav);

component.authorization = { action: 'manage', subject: BUILDER };

export default component;
